/**
 * 约束类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 约束类型
 */
enum ConstraintType {
    /**
     * 唯一约束
     */
    Unique = 0,
}

export { ConstraintType };

